import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, ArrowLeft, CreditCard } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { toast } = useToast();
  const [verifying, setVerifying] = useState(true);

  const invoiceId = searchParams.get('invoice');

  useEffect(() => {
    // Show success toast
    toast({
      title: "Payment Successful!",
      description: "Your payment has been processed successfully.",
      variant: "default",
    });

    // Simulate verification process
    const timer = setTimeout(() => {
      setVerifying(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [toast]);

  const handleBackToOrders = () => {
    navigate('/orders');
  };

  return (
    <div className="min-h-screen bg-gradient-elegant flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-100 text-green-600">
              <CheckCircle2 className="h-8 w-8" />
            </div>
          </div>
          <CardTitle className="text-2xl text-green-700">Payment Successful!</CardTitle>
        </CardHeader>
        <CardContent className="text-center space-y-4">
          {verifying ? (
            <div className="space-y-3">
              <div className="animate-pulse text-muted-foreground">
                Verifying payment...
              </div>
              <div className="flex justify-center">
                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
              </div>
            </div>
          ) : (
            <div className="space-y-4">
              <p className="text-muted-foreground">
                Your payment has been processed successfully and your invoice has been updated.
              </p>
              {invoiceId && (
                <div className="bg-muted/50 rounded-lg p-3">
                  <div className="flex items-center justify-center gap-2 text-sm">
                    <CreditCard className="h-4 w-4" />
                    <span>Invoice Payment Confirmed</span>
                  </div>
                </div>
              )}
              <Button onClick={handleBackToOrders} className="w-full">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to Orders
              </Button>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}